import React from 'react';
import { Link } from 'react-router-dom';
import './PageHero.css';

const PageHero = ({ title, description, showButton = true }) => {
    return (
        <section className="page-hero-section">
            {/* Moving Circles */}
            <div className="ph-circle-1"></div>
            <div className="ph-circle-2"></div>
            <div className="ph-circle-3"></div>

            <div className="container page-hero-content">
                <h1 className="page-hero-title">{title}</h1>

                {description && (
                    <p className="page-hero-text">{description}</p>
                )}

                {showButton && (
                    <Link to="/contact" className="btn btn-page-hero">
                        Book Visit
                    </Link>
                )}
            </div>
        </section>
    );
};

export default PageHero;
